import { Team } from '../../../../../../types/sport';
import { ESPN_HEROS_BASE_URL } from '../../urls';
import { ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES } from './bundesliga-player-images';

const BASE_FACE_URL = `${ESPN_HEROS_BASE_URL}/bundesliga`;

export const ESPN_HERO_BUNDESLIGA_TEAMS: Team[] = [
  {
    value: 'augsburg',
    label: 'Augsburg',
    players: [
      {
        value: 'essende-samuel',
        label: 'Essende Samuel',
        country: 'camerun',
        imageUrl: `${BASE_FACE_URL}/augsburg/essende-samuel/face/essende-samuel.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.augsburg['essende-samuel']
      },
      {
        value: 'fabian-rieder',
        label: 'Fabian Rieder',
        country: 'suiza',
        imageUrl: `${BASE_FACE_URL}/augsburg/fabian-rieder/face/fabian-rieder.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.augsburg['fabian-rieder']
      },
      {
        value: 'han-noah-massengo',
        label: 'Han-Noah Massengo',
        country: 'francia',
        imageUrl: `${BASE_FACE_URL}/augsburg/han-noah-massengo/face/han-noah-massengo.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.augsburg['han-noah-massengo']
      },
      {
        value: 'michael-gregoritsch',
        label: 'Michael Gregoritsch',
        country: 'austria',
        imageUrl: `${BASE_FACE_URL}/augsburg/michael-gregoritsch/face/michael-gregoritsch.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.augsburg['michael-gregoritsch']
      },
      {
        value: 'phillip-tietz',
        label: 'Phillip Tietz',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/augsburg/phillip-tietz/face/phillip-tietz.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.augsburg['phillip-tietz']
      }
    ]
  },
  {
    value: 'bayern',
    label: 'Bayern München',
    players: [
      {
        value: 'harry-kane',
        label: 'Harry Kane',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/bayern/harry-kane/face/harry-kane.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.bayern['harry-kane']
      },
      {
        value: 'joshua-kimmich',
        label: 'Joshua Kimmich',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/bayern/joshua-kimmich/face/joshua-kimmich.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.bayern['joshua-kimmich']
      },
      {
        value: 'luis-diaz',
        label: 'Luis Díaz',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/bayern/luis-diaz/face/luis-diaz.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.bayern['luis-diaz']
      }
    ]
  },
  {
    value: 'bremen',
    label: 'Werder Bremen',
    players: [
      {
        value: 'julian-malatini',
        label: 'Julian Malatini',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/bremen/julian-malatini/face/julian-malatini.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.bremen['julian-malatini']
      },
      {
        value: 'marco-grull',
        label: 'Marco Grüll',
        country: 'austria',
        imageUrl: `${BASE_FACE_URL}/bremen/marco-grull/face/marco-grull.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.bremen['marco-grull']
      },
      {
        value: 'marvin-ducksch',
        label: 'Marvin Ducksch',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/bremen/marvin-ducksch/face/marvin-ducksch.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.bremen['marvin-ducksch']
      },
      {
        value: 'romano-schmid',
        label: 'Romano Schmid',
        country: 'austria',
        imageUrl: `${BASE_FACE_URL}/bremen/romano-schmid/face/romano-schmid.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.bremen['romano-schmid']
      }
    ]
  },
  {
    value: 'dortmund',
    label: 'Borussia Dortmund',
    players: [
      {
        value: 'jobe-bellingham',
        label: 'Jobe Bellingham',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/dortmund/jobe-bellingham/face/jobe-bellingham.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.dortmund['jobe-bellingham']
      },
      {
        value: 'julian-brandt',
        label: 'Julian Brandt',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/dortmund/julian-brandt/face/julian-brandt.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.dortmund['julian-brandt']
      },
      {
        value: 'karim-adeyemi',
        label: 'Karim Adeyemi',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/dortmund/karim-adeyemi/face/karim-adeyemi.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.dortmund['karim-adeyemi']
      },
      {
        value: 'marcel-sabitzer',
        label: 'Marcel Sabitzer',
        country: 'austria',
        imageUrl: `${BASE_FACE_URL}/dortmund/marcel-sabitzer/face/marcel-sabitzer.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.dortmund['marcel-sabitzer']
      }
    ]
  },
  {
    value: 'frankfurt',
    label: 'Eintracht Frankfurt',
    players: [
      {
        value: 'ansgar-knauff',
        label: 'Ansgar Knauff',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/frankfurt/ansgar-knauff/face/ansgar-knauff.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.frankfurt['ansgar-knauff']
      },
      {
        value: 'can-uzun',
        label: 'Can Uzun',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/frankfurt/can-uzun/face/can-uzun.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.frankfurt['can-uzun']
      },
      {
        value: 'mahmoud-dahoud',
        label: 'Mahmoud Dahoud',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/frankfurt/mahmoud-dahoud/face/mahmoud-dahoud.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.frankfurt['mahmoud-dahoud']
      },
      {
        value: 'mario-gotze',
        label: 'Mario Götze',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/frankfurt/mario-gotze/face/mario-gotze.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.frankfurt['mario-gotze']
      },
      {
        value: 'michy-batshuayi',
        label: 'Michy Batshuayi',
        country: 'belgica',
        imageUrl: `${BASE_FACE_URL}/frankfurt/michy-batshuayi/face/michy-batshuayi.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.frankfurt['michy-batshuayi']
      },
      {
        value: 'ritsu-doan',
        label: 'Ritsu Doan',
        country: 'japon',
        imageUrl: `${BASE_FACE_URL}/frankfurt/ritsu-doan/face/ritsu-doan.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.frankfurt['ritsu-doan']
      }
    ]
  },
  {
    value: 'freiburg',
    label: 'SC Freiburg',
    players: [
      {
        value: 'derry-scherhant',
        label: 'Derry Scherhant',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/freiburg/derry-scherhant/face/derry-scherhant.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.freiburg['derry-scherhant']
      },
      {
        value: 'johan-manzambi',
        label: 'Johan Manzambi',
        country: 'belgica',
        imageUrl: `${BASE_FACE_URL}/freiburg/johan-manzambi/face/johan-manzambi.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.freiburg['johan-manzambi']
      },
      {
        value: 'lucas-holer',
        label: 'Lucas Höler',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/freiburg/lucas-holer/face/lucas-holer.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.freiburg['lucas-holer']
      },
      {
        value: 'niklas-beste',
        label: 'Niklas Beste',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/freiburg/niklas-beste/face/niklas-beste.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.freiburg['niklas-beste']
      },
      {
        value: 'philipp-treu',
        label: 'Philipp Treu',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/freiburg/philipp-treu/face/philipp-treu.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.freiburg['philipp-treu']
      }
    ]
  },
  {
    value: 'gladbach',
    label: 'Borussia Mönchengladbach',
    players: [
      {
        value: 'joe-scally',
        label: 'Joe Scally',
        country: 'usa',
        imageUrl: `${BASE_FACE_URL}/gladbach/joe-scally/face/joe-scally.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.gladbach['joe-scally']
      },
      {
        value: 'nico-elvedi',
        label: 'Nico Elvedi',
        country: 'suiza',
        imageUrl: `${BASE_FACE_URL}/gladbach/nico-elvedi/face/nico-elvedi.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.gladbach['nico-elvedi']
      },
      {
        value: 'rocco-reitz',
        label: 'Rocco Reitz',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/gladbach/rocco-reitz/face/rocco-reitz.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.gladbach['rocco-reitz']
      }
    ]
  },
  {
    value: 'hamburg',
    label: 'Hamburger SV',
    players: [
      {
        value: 'nicolas-capaldo',
        label: 'Nicolás Capaldo',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/hamburg/nicolas-capaldo/face/nicolas-capaldo.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.hamburg['nicolas-capaldo']
      },
      {
        value: 'rayan-philippe',
        label: 'Rayan Philippe',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/hamburg/rayan-philippe/face/rayan-philippe.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.hamburg['rayan-philippe']
      },
      {
        value: 'yussuf-poulsen',
        label: 'Yussuf Poulsen',
        country: 'dinamarca',
        imageUrl: `${BASE_FACE_URL}/hamburg/yussuf-poulsen/face/yussuf-poulsen.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.hamburg['yussuf-poulsen']
      }
    ]
  },
  {
    value: 'heidenheim',
    label: 'FC Heidenheim',
    players: [
      {
        value: 'benedikt-gimber',
        label: 'Benedikt Gimber',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/heidenheim/benedikt-gimber/face/benedikt-gimber.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.heidenheim['benedikt-gimber']
      },
      {
        value: 'marvin-pieringer',
        label: 'Marvin Pieringer',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/heidenheim/marvin-pieringer/face/marvin-pieringer.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.heidenheim['marvin-pieringer']
      },
      {
        value: 'niklas-dorsch',
        label: 'Niklas Dorsch',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/heidenheim/niklas-dorsch/face/niklas-dorsch.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.heidenheim['niklas-dorsch']
      }
    ]
  },
  {
    value: 'hoffenheim',
    label: 'TSG Hoffenheim',
    players: [
      {
        value: 'bazoumana-toure',
        label: 'Bazoumana Touré',
        country: 'burkina_faso',
        imageUrl: `${BASE_FACE_URL}/hoffenheim/bazoumana-toure/face/bazoumana-toure.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.hoffenheim['bazoumana-toure']
      },
      {
        value: 'fisnik-asllani',
        label: 'Fisnik Asllani',
        country: 'kosovo',
        imageUrl: `${BASE_FACE_URL}/hoffenheim/fisnik-asllani/face/fisnik-asllani.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.hoffenheim['fisnik-asllani']
      }
    ]
  },
  {
    value: 'koln',
    label: '1. FC Köln',
    players: [
      {
        value: 'eric-martel',
        label: 'Eric Martel',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/koln/eric-martel/face/eric-martel.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.koln['eric-martel']
      },
      {
        value: 'florian-kainz',
        label: 'Florian Kainz',
        country: 'austria',
        imageUrl: `${BASE_FACE_URL}/koln/florian-kainz/face/florian-kainz.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.koln['florian-kainz']
      },
      {
        value: 'isak-johannesson',
        label: 'Isak Johannesson',
        country: 'suecia',
        imageUrl: `${BASE_FACE_URL}/koln/isak-johannesson/face/isak-johannesson.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.koln['isak-johannesson']
      }
    ]
  },
  {
    value: 'leipzig',
    label: 'RB Leipzig',
    players: [
      {
        value: 'johan-bakayoko',
        label: 'Johan Bakayoko',
        country: 'belgica',
        imageUrl: `${BASE_FACE_URL}/leipzig/johan-bakayoko/face/johan-bakayoko.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.leipzig['johan-bakayoko']
      },
      {
        value: 'willi-orban',
        label: 'Willi Orbán',
        country: 'hungria',
        imageUrl: `${BASE_FACE_URL}/leipzig/willi-orban/face/willi-orban.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.leipzig['willi-orban']
      }
    ]
  },
  {
    value: 'leverkusen',
    label: 'Bayer Leverkusen',
    players: [
      {
        value: 'alejandro-grimaldo',
        label: 'Alejandro Grimaldo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/leverkusen/alejandro-grimaldo/face/alejandro-grimaldo.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.leverkusen['alejandro-grimaldo']
      },
      {
        value: 'exequiel-palacios',
        label: 'Exequiel Palacios',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/leverkusen/exequiel-palacios/face/exequiel-palacios.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.leverkusen['exequiel-palacios']
      },
      {
        value: 'ezequiel-fernandez',
        label: 'Ezequiel Fernández',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/leverkusen/ezequiel-fernandez/face/ezequiel-fernandez.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.leverkusen['ezequiel-fernandez']
      },
      {
        value: 'patrik-schick',
        label: 'Patrik Schick',
        country: 'republica_checa',
        imageUrl: `${BASE_FACE_URL}/leverkusen/patrik-schick/face/patrik-schick.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.leverkusen['patrik-schick']
      }
    ]
  },
  {
    value: 'mainz',
    label: '1. FSV Mainz 05',
    players: [
      {
        value: 'armindo-sieb',
        label: 'Armindo Sieb',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/mainz/armindo-sieb/face/armindo-sieb.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.mainz['armindo-sieb']
      },
      {
        value: 'jae-sung-lee',
        label: 'Jae-sung Lee',
        country: 'corea_del_sur',
        imageUrl: `${BASE_FACE_URL}/mainz/jae-sung-lee/face/jae-sung-lee.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.mainz['jae-sung-lee']
      },
      {
        value: 'nadiem-amiri',
        label: 'Nadiem Amiri',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/mainz/nadiem-amiri/face/nadiem-amiri.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.mainz['nadiem-amiri']
      }
    ]
  },
  {
    value: 'st-pauli',
    label: 'FC St. Pauli',
    players: [
      {
        value: 'andreas-hountondji',
        label: 'Andreas Hountondji',
        country: 'benin',
        imageUrl: `${BASE_FACE_URL}/st-pauli/andreas-hountondji/face/andreas-hountondji.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES['st-pauli']['andreas-hountondji']
      },
      {
        value: 'danel-sinani',
        label: 'Danel Sinani',
        country: 'luxemburgo',
        imageUrl: `${BASE_FACE_URL}/st-pauli/danel-sinani/face/danel-sinani.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES['st-pauli']['danel-sinani']
      },
      {
        value: 'joel-chima-fujita',
        label: 'Joel Chima Fujita',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/st-pauli/joel-chima-fujita/face/joel-chima-fujita.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES['st-pauli']['joel-chima-fujita']
      },
      {
        value: 'mathias-pereira-lage',
        label: 'Mathias Pereira Lage',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/st-pauli/mathias-pereira-lage/face/mathias-pereira-lage.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES['st-pauli']['mathias-pereira-lage']
      }
    ]
  },
  {
    value: 'stuttgart',
    label: 'VfB Stuttgart',
    players: [
      {
        value: 'angelo-stiller',
        label: 'Angelo Stiller',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/stuttgart/angelo-stiller/face/angelo-stiller.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.stuttgart['angelo-stiller']
      },
      {
        value: 'deniz-undav',
        label: 'Deniz Undav',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/stuttgart/deniz-undav/face/deniz-undav.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.stuttgart['deniz-undav']
      },
      {
        value: 'ermedin-demirovic',
        label: 'Ermedin Demirovic',
        country: 'bosnia_herzegovina',
        imageUrl: `${BASE_FACE_URL}/stuttgart/ermedin-demirovic/face/ermedin-demirovic.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.stuttgart['ermedin-demirovic']
      }
    ]
  },
  {
    value: 'union-berlin',
    label: '1. FC Union Berlin',
    players: [
      {
        value: 'ilyas-ansah',
        label: 'Ilyas Ansah',
        country: 'dinamarca',
        imageUrl: `${BASE_FACE_URL}/union-berlin/ilyas-ansah/face/ilyas-ansah.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES['union-berlin']['ilyas-ansah']
      },
      {
        value: 'tom-rothe',
        label: 'Tom Rothe',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/union-berlin/tom-rothe/face/tom-rothe.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES['union-berlin']['tom-rothe']
      }
    ]
  },
  {
    value: 'wolfsburg',
    label: 'VfL Wolfsburg',
    players: [
      {
        value: 'christian-eriksen',
        label: 'Christian Eriksen',
        country: 'dinamarca',
        imageUrl: `${BASE_FACE_URL}/wolfsburg/christian-eriksen/face/christian-eriksen.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.wolfsburg['christian-eriksen']
      },
      {
        value: 'maximilian-arnold',
        label: 'Maximilian Arnold',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/wolfsburg/maximilian-arnold/face/maximilian-arnold.png`,
        images: ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES.wolfsburg['maximilian-arnold']
      }
    ]
  }
];
